<!--begin::Main-->
<div class="d-flex flex-column vh-100">
    <!--begin::Authentication Layout -->
    <div class="d-flex flex-column flex-lg-row h-100">
        <!--begin::Aside-->
        <div class="d-flex flex-column bg-primary col-lg-6 col-xl-5">
            <!--begin::Wrapper-->
            <div class="d-flex flex-column h-100 p-4 p-lg-5">
                <!--begin::Header-->
                <div class="d-flex flex-column text-center flex-grow-1 justify-content-center">          
                    <!--begin::Logo-->
                    <div class="mb-4 mb-lg-5">
                        <a [routerLink]="['/']" class="d-inline-block">
                            <img alt="Logo" src="/ms/images/logos/HOAStart-Logo-no-blue-text.svg" class="img-fluid" style="height: 60px;">
                        </a>
                    </div>    
                    <!--end::Logo-->

                    <!--begin::Title-->
                    <h1 class="d-none d-lg-block fw-bold text-white display-5 mb-4">
                        Welcome!
                    </h1>
                    <!--end::Title-->

                    <!--begin::Description-->
                    <p class="d-none d-lg-block fw-bold h4 text-white mb-0">
                        Reclaim your HOA
                    </p>
                    <!--end::Description-->
                </div>
                <!--end::Header-->

                <!--begin::Illustration-->
                <div class="d-none d-lg-block mt-auto text-center">
                    <!-- <img src="https://preview.keenthemes.com/craft/assets/media/illustrations/sigma-1/17.png" alt="Authentication Illustration" class="img-fluid" style="max-height: 400px;"> -->
                </div>
                <!--end::Illustration-->
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Aside-->

        <!--begin::Body-->
        <div class="d-flex flex-column col-lg-6 col-xl-7">
            <div class="position-absolute top-0 end-0 p-1 d-none d-lg-block">
                <ms-theme-switcher></ms-theme-switcher>
            </div>
            <div class="position-absolute top-0 end-0 p-1 d-lg-none">
                <ms-theme-switcher [colorClass]="'btn-primary'"></ms-theme-switcher>
            </div>
            <!--begin::Content-->
            <div class="d-flex flex-column justify-content-center align-items-center flex-grow-1 p-5">
                <!--begin::Wrapper-->
                <div class="w-100" style="max-width: 500px;">
                    
                    <router-outlet></router-outlet>

                </div>
                <!--end::Wrapper-->
            </div>
            <!--end::Content-->
        </div>
        <!--end::Body-->
    </div>
    <!--end::Authentication Layout-->
</div>
<!--end::Main-->
